export default __webpack_public_path__ + "static/media/modalBuddies@2x.97eeae31.png";